(function ($) {
    var activeTab = splitUrlQuery(window.location.search);
    if(typeof activeTab !== 'undefined') {
        redirect(activeTab);
    }
    var $btn = $('[data-redirect]');
    $btn.on('click', function() {
        redirect($(this).data('redirect').toString());
        $('html, body').animate({
            scrollTop: $($(this).data('target')).offset().top
        }, 500);
    });
}(jQuery));

function redirect(page) {
    var $navTabs = $('.nav-tab__link--conference');
    var $navTabsMobile = $('.nav-tab__link--conference-mobile');
    $navTabs.removeClass('nav-tab__link--active');
    $navTabsMobile.removeClass('nav-tab__link--active');
    for (var i = 0; i < $navTabs.length; i++) {
        if($($navTabs[i]).data('nav-tab').toString() === page) {
            $($navTabs[i]).addClass('nav-tab__link--active');
            angular.element('.nav-tab__link--mobile[data-nav-tab="' + page + '"]').trigger('click');
        }
        if($($navTabsMobile[i]).data('nav-tab').toString() === page) {
            $($navTabsMobile[i]).addClass('nav-tab__link--active');
        }
    }
}

function splitUrlQuery(url) {
    var urlVariables = url.substring(1).split('&');
    for (var i = 0; i < urlVariables.length; i++) {
        var param = urlVariables[i].split('=');
        if(param[0] === 'tab') {
            return param[1];
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/conference-redirect/conference-redirect.js